
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_csnjq_32",
  "input": "awsui_input_2rhyz_csnjq_36",
  "input-readonly": "awsui_input-readonly_2rhyz_csnjq_89",
  "input-invalid": "awsui_input-invalid_2rhyz_csnjq_133",
  "input-warning": "awsui_input-warning_2rhyz_csnjq_136",
  "input-type-search": "awsui_input-type-search_2rhyz_csnjq_139",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_csnjq_149",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_csnjq_152",
  "input-container": "awsui_input-container_2rhyz_csnjq_156",
  "input-field": "awsui_input-field_2rhyz_csnjq_161",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_csnjq_185",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_csnjq_200",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_csnjq_208",
  "input-field-warning": "awsui_input-field-warning_2rhyz_csnjq_222",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_csnjq_236",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_csnjq_236",
  "grouped": "awsui_grouped_2rhyz_csnjq_251",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_csnjq_261",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_csnjq_265",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_csnjq_271",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_csnjq_275",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_csnjq_279",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_csnjq_285",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_csnjq_289",
  "with-error": "awsui_with-error_2rhyz_csnjq_293",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_csnjq_321",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_csnjq_321",
  "with-warning": "awsui_with-warning_2rhyz_csnjq_327",
  "grouped-validation-first": "awsui_grouped-validation-first_2rhyz_csnjq_369",
  "input-prefix": "awsui_input-prefix_2rhyz_csnjq_376",
  "input-suffix": "awsui_input-suffix_2rhyz_csnjq_377",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_csnjq_391",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_csnjq_400",
  "input-icon-start": "awsui_input-icon-start_2rhyz_csnjq_426",
  "input-icon-start-disabled": "awsui_input-icon-start-disabled_2rhyz_csnjq_433",
  "input-icon-end": "awsui_input-icon-end_2rhyz_csnjq_437",
  "input-button-right": "awsui_input-button-right_2rhyz_csnjq_443",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_csnjq_447",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_csnjq_450",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_csnjq_454",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_csnjq_457",
  "inline-label": "awsui_inline-label_2rhyz_csnjq_447",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_csnjq_482"
};
  